import React, { useState, useEffect } from 'react';
import { Line, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

/**
 * Widget de Gráficos - Soporta diferentes tipos de visualización
 */
const ChartWidget = ({ widget }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [widget.type]);

  const loadData = async () => {
    // Simular carga de datos
    // TODO: Conectar con API real
    setTimeout(() => {
      if (widget.type === 'chart-investment-timeline') {
        setData({
          labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun'],
          datasets: [{
            label: 'Inversión',
            data: [12000, 19000, 15000, 25000, 22000, 30000],
            borderColor: 'rgb(75, 192, 192)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            fill: true,
            tension: 0.4
          }]
        });
      } else if (widget.type === 'chart-client-distribution') {
        setData({
          labels: ['Ford', 'UTPL', 'Claro', 'Otros'],
          datasets: [{
            data: [35, 25, 20, 20],
            backgroundColor: [
              'rgba(255, 99, 132, 0.8)',
              'rgba(54, 162, 235, 0.8)',
              'rgba(255, 206, 86, 0.8)',
              'rgba(75, 192, 192, 0.8)'
            ],
            borderWidth: 1
          }]
        });
      }
      setLoading(false);
    }, 500);
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          padding: 10,
          font: {
            size: 11
          }
        }
      }
    }
  };

  return (
    <div className="chart-widget" style={{ height: '100%', minHeight: '200px' }}>
      {widget.type === 'chart-investment-timeline' && (
        <Line data={data} options={chartOptions} />
      )}
      {widget.type === 'chart-client-distribution' && (
        <Doughnut data={data} options={chartOptions} />
      )}
    </div>
  );
};

export default ChartWidget;




